import script from "./commonHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonHeader.vue?vue&type=script&setup=true&lang=ts"

import "./commonHeader.vue?vue&type=style&index=0&id=d087bd60&lang=scss"
import "./commonHeader.vue?vue&type=style&index=1&id=d087bd60&lang=css"

const __exports__ = script;

export default __exports__